import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommitmentsHelpStep4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 121,
	height: 60,
	viewBox: "0 0 121 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 121,
			height: 59.5294,
			rx: 3.88235,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_2548_13688",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M0.646973 2.58826H25.2352V31.0588H0.646973V2.58826Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.2352 30.4118H0.646973V31.7059H25.2352V30.4118Z",
			fill: "#F4F6F9",
			mask: "url(#path-2-inside-1_2548_13688)"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_2548_13688)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 8.73515,
				y: 11.9706,
				width: 9.70588,
				height: 9.70588,
				rx: 2.26471,
				fill: "white",
				stroke: "#E1E7EA",
				strokeWidth: .647059
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-5-inside-2_2548_13688",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M25.2354 2.58826H49.8236V31.0588H25.2354V2.58826Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.8236 30.4118H25.2354V31.7059H49.8236V30.4118Z",
			fill: "#F4F6F9",
			mask: "url(#path-5-inside-2_2548_13688)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33,
			y: 11.6471,
			width: 16.8235,
			height: 10.3529,
			rx: 5.17647,
			fill: "#BAC3C8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38.1764,
			cy: 16.8236,
			r: 4.52941,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-9-inside-3_2548_13688",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M49.8232 2.58826H120.353V31.0588H49.8232V2.58826Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.353 30.4118H49.8232V31.7059H120.353V30.4118Z",
			fill: "#F4F6F9",
			mask: "url(#path-9-inside-3_2548_13688)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.1708 19.8236H59.0837L56.6223 16.1043V19.8236H55.5353V14.3961H56.6223L59.0837 18.1231V14.3961H60.1708V19.8236ZM65.2154 18.7909H63.0568L62.6997 19.8236H61.5582L63.5072 14.3961H64.7728L66.7218 19.8236H65.5726L65.2154 18.7909ZM64.9204 17.9213L64.1361 15.654L63.3519 17.9213H64.9204ZM74.0063 14.4038V19.8236H72.9192V16.2984L71.4672 19.8236H70.6441L69.1844 16.2984V19.8236H68.0973V14.4038H69.3319L71.0557 18.4337L72.7794 14.4038H74.0063ZM76.8151 15.2813V16.6401H78.6398V17.502H76.8151V18.9384H78.8728V19.8236H75.7281V14.3961H78.8728V15.2813H76.8151Z",
			fill: "#112934"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.7642 20.7059C89.9084 20.7059 91.6465 18.9677 91.6465 16.8235C91.6465 14.6794 89.9084 12.9412 87.7642 12.9412C85.62 12.9412 83.8818 14.6794 83.8818 16.8235C83.8818 18.9677 85.62 20.7059 87.7642 20.7059Z",
			stroke: "#112934",
			strokeWidth: .647059,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.4409 16.5H87.7644V18.7647H88.088",
			stroke: "#112934",
			strokeWidth: .647059,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.9665 15.0441C87.9665 15.2005 87.8397 15.3272 87.6834 15.3272C87.527 15.3272 87.4003 15.2005 87.4003 15.0441C87.4003 14.8878 87.527 14.761 87.6834 14.761C87.8397 14.761 87.9665 14.8878 87.9665 15.0441Z",
			fill: "#112934",
			stroke: "#112934",
			strokeWidth: .0808824
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.764 18.7648L97.4699 20.0589L96.1758 18.7648",
			stroke: "#839299",
			strokeWidth: .647059,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.4702 13.5883V20.0588",
			stroke: "#839299",
			strokeWidth: .647059,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.059 14.8824L101.353 13.5883L102.647 14.8824",
			stroke: "#839299",
			strokeWidth: .647059,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.353 20.0588V13.5883",
			stroke: "#839299",
			strokeWidth: .647059,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.73515,
			y: 39.147,
			width: 9.70588,
			height: 9.70588,
			rx: 2.26471,
			fill: "white",
			stroke: "#E1E7EA",
			strokeWidth: .647059
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33,
			y: 38.8235,
			width: 16.8235,
			height: 10.3529,
			rx: 5.17647,
			fill: "#417AE9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 44.6471,
			cy: 44,
			r: 4.52941,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.467 43.5193C56.5965 43.3019 56.7673 43.1337 56.9795 43.0146C57.1969 42.8904 57.4532 42.8283 57.7482 42.8283V43.7445H57.523C57.1762 43.7445 56.9122 43.8325 56.731 44.0085C56.555 44.1845 56.467 44.4899 56.467 44.9247V47.1765H55.5819V42.8982H56.467V43.5193ZM59.4471 41.4306V47.1765H58.5619V41.4306H59.4471ZM65.3379 47.4871V48.3102H61.0052V47.4871H65.3379ZM67.6895 43.5193C67.8189 43.3019 67.9897 43.1337 68.2019 43.0146C68.4194 42.8904 68.6756 42.8283 68.9706 42.8283V43.7445H68.7455C68.3986 43.7445 68.1346 43.8325 67.9535 44.0085C67.7775 44.1845 67.6895 44.4899 67.6895 44.9247V47.1765H66.8043V42.8982H67.6895V43.5193ZM73.7055 44.9325C73.7055 45.093 73.6951 45.2379 73.6744 45.3673H70.4055C70.4314 45.709 70.5582 45.9833 70.7859 46.1904C71.0137 46.3975 71.2932 46.501 71.6245 46.501C72.1008 46.501 72.4372 46.3017 72.6339 45.9031H73.589C73.4596 46.2965 73.2241 46.62 72.8824 46.8737C72.5459 47.1222 72.1267 47.2464 71.6245 47.2464C71.2156 47.2464 70.8481 47.1558 70.5219 46.9746C70.201 46.7883 69.9474 46.5295 69.761 46.1982C69.5798 45.8617 69.4892 45.4735 69.4892 45.0335C69.4892 44.5935 69.5772 44.2078 69.7532 43.8765C69.9344 43.54 70.1855 43.2812 70.5064 43.1C70.8325 42.9189 71.2052 42.8283 71.6245 42.8283C72.0283 42.8283 72.3881 42.9163 72.7038 43.0923C73.0196 43.2683 73.2655 43.5167 73.4415 43.8377C73.6175 44.1535 73.7055 44.5184 73.7055 44.9325ZM72.7815 44.653C72.7763 44.3269 72.6598 44.0655 72.4321 43.8687C72.2043 43.672 71.9222 43.5737 71.5857 43.5737C71.2803 43.5737 71.0189 43.672 70.8015 43.8687C70.5841 44.0603 70.4547 44.3217 70.4132 44.653H72.7815ZM76.1295 47.2464C75.7931 47.2464 75.4902 47.1869 75.2211 47.0678C74.9571 46.9436 74.7474 46.7779 74.5921 46.5709C74.4368 46.3586 74.354 46.1231 74.3436 45.8643H75.2599C75.2754 46.0455 75.3608 46.1982 75.5161 46.3224C75.6766 46.4415 75.8759 46.501 76.114 46.501C76.3625 46.501 76.554 46.4544 76.6886 46.3612C76.8283 46.2629 76.8982 46.1386 76.8982 45.9885C76.8982 45.828 76.8206 45.709 76.6653 45.6313C76.5152 45.5537 76.2745 45.4683 75.9432 45.3751C75.6222 45.2871 75.3608 45.2017 75.1589 45.1189C74.9571 45.036 74.7811 44.9092 74.6309 44.7384C74.486 44.5676 74.4135 44.3424 74.4135 44.0629C74.4135 43.8351 74.4808 43.628 74.6154 43.4417C74.75 43.2502 74.9415 43.1 75.19 42.9913C75.4436 42.8826 75.7335 42.8283 76.0596 42.8283C76.5462 42.8283 76.9371 42.9525 77.2321 43.201C77.5323 43.4443 77.6928 43.7782 77.7135 44.2026H76.8283C76.8128 44.0111 76.7352 43.8584 76.5954 43.7445C76.4556 43.6306 76.2667 43.5737 76.0286 43.5737C75.7956 43.5737 75.6171 43.6177 75.4928 43.7057C75.3686 43.7937 75.3065 43.9102 75.3065 44.0551C75.3065 44.169 75.3479 44.2647 75.4307 44.3424C75.5135 44.42 75.6145 44.4822 75.7335 44.5287C75.8526 44.5702 76.0286 44.6245 76.2615 44.6918C76.5721 44.7746 76.8258 44.86 77.0225 44.948C77.2243 45.0309 77.3978 45.1551 77.5427 45.3207C77.6876 45.4864 77.7627 45.7064 77.7679 45.9807C77.7679 46.224 77.7006 46.4415 77.566 46.633C77.4314 46.8245 77.2399 46.9746 76.9914 47.0833C76.7481 47.192 76.4608 47.2464 76.1295 47.2464ZM83.453 47.4871V48.3102H79.1203V47.4871H83.453ZM85.8046 43.5271C85.9547 43.3304 86.1592 43.1647 86.418 43.0302C86.6768 42.8956 86.9693 42.8283 87.2954 42.8283C87.6681 42.8283 88.0072 42.9215 88.3126 43.1078C88.6232 43.289 88.8665 43.5452 89.0425 43.8765C89.2185 44.2078 89.3065 44.5883 89.3065 45.0179C89.3065 45.4476 89.2185 45.8332 89.0425 46.1749C88.8665 46.5113 88.6232 46.7753 88.3126 46.9669C88.0072 47.1532 87.6681 47.2464 87.2954 47.2464C86.9693 47.2464 86.6794 47.1817 86.4258 47.0523C86.1721 46.9177 85.9651 46.752 85.8046 46.5553V49.2109H84.9194V42.8982H85.8046V43.5271ZM88.4058 45.0179C88.4058 44.7229 88.3436 44.4692 88.2194 44.257C88.1004 44.0396 87.9399 43.8765 87.738 43.7678C87.5413 43.6539 87.3291 43.597 87.1013 43.597C86.8787 43.597 86.6665 43.6539 86.4646 43.7678C86.2679 43.8817 86.1074 44.0473 85.9832 44.2647C85.8641 44.4822 85.8046 44.7384 85.8046 45.0335C85.8046 45.3285 85.8641 45.5873 85.9832 45.8099C86.1074 46.0273 86.2679 46.193 86.4646 46.3069C86.6665 46.4207 86.8787 46.4777 87.1013 46.4777C87.3291 46.4777 87.5413 46.4207 87.738 46.3069C87.9399 46.1878 88.1004 46.017 88.2194 45.7944C88.3436 45.5718 88.4058 45.313 88.4058 45.0179ZM91.067 43.5193C91.1964 43.3019 91.3672 43.1337 91.5795 43.0146C91.7969 42.8904 92.0531 42.8283 92.3482 42.8283V43.7445H92.123C91.7762 43.7445 91.5122 43.8325 91.331 44.0085C91.155 44.1845 91.067 44.4899 91.067 44.9247V47.1765H90.1818V42.8982H91.067V43.5193ZM95.0176 47.2464C94.6138 47.2464 94.2489 47.1558 93.9228 46.9746C93.5967 46.7883 93.3404 46.5295 93.1541 46.1982C92.9677 45.8617 92.8745 45.4735 92.8745 45.0335C92.8745 44.5986 92.9703 44.213 93.1618 43.8765C93.3534 43.54 93.6148 43.2812 93.9461 43.1C94.2774 42.9189 94.6475 42.8283 95.0564 42.8283C95.4654 42.8283 95.8355 42.9189 96.1668 43.1C96.4981 43.2812 96.7595 43.54 96.951 43.8765C97.1425 44.213 97.2383 44.5986 97.2383 45.0335C97.2383 45.4683 97.1399 45.8539 96.9432 46.1904C96.7465 46.5269 96.4774 46.7883 96.1357 46.9746C95.7992 47.1558 95.4265 47.2464 95.0176 47.2464ZM95.0176 46.4777C95.2454 46.4777 95.4576 46.4233 95.6543 46.3146C95.8562 46.2059 96.0192 46.0429 96.1435 45.8255C96.2677 45.608 96.3298 45.344 96.3298 45.0335C96.3298 44.7229 96.2703 44.4615 96.1512 44.2492C96.0322 44.0318 95.8743 43.8687 95.6776 43.76C95.4809 43.6513 95.2687 43.597 95.0409 43.597C94.8131 43.597 94.6009 43.6513 94.4042 43.76C94.2127 43.8687 94.0599 44.0318 93.9461 44.2492C93.8322 44.4615 93.7752 44.7229 93.7752 45.0335C93.7752 45.4942 93.8917 45.8513 94.1247 46.105C94.3628 46.3535 94.6604 46.4777 95.0176 46.4777ZM97.8183 45.0179C97.8183 44.5883 97.9063 44.2078 98.0823 43.8765C98.2635 43.5452 98.5068 43.289 98.8122 43.1078C99.1228 42.9215 99.467 42.8283 99.8449 42.8283C100.124 42.8283 100.399 42.8904 100.668 43.0146C100.942 43.1337 101.16 43.2942 101.32 43.496V41.4306H102.213V47.1765H101.32V46.532C101.175 46.7391 100.973 46.9099 100.715 47.0445C100.461 47.1791 100.168 47.2464 99.8371 47.2464C99.4644 47.2464 99.1228 47.1532 98.8122 46.9669C98.5068 46.7753 98.2635 46.5113 98.0823 46.1749C97.9063 45.8332 97.8183 45.4476 97.8183 45.0179ZM101.32 45.0335C101.32 44.7384 101.258 44.4822 101.134 44.2647C101.015 44.0473 100.857 43.8817 100.66 43.7678C100.463 43.6539 100.251 43.597 100.023 43.597C99.7957 43.597 99.5835 43.6539 99.3868 43.7678C99.1901 43.8765 99.0296 44.0396 98.9053 44.257C98.7863 44.4692 98.7268 44.7229 98.7268 45.0179C98.7268 45.313 98.7863 45.5718 98.9053 45.7944C99.0296 46.017 99.1901 46.1878 99.3868 46.3069C99.5886 46.4207 99.8009 46.4777 100.023 46.4777C100.251 46.4777 100.463 46.4207 100.66 46.3069C100.857 46.193 101.015 46.0273 101.134 45.8099C101.258 45.5873 101.32 45.3285 101.32 45.0335Z",
			fill: "#417AE9"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2548_13688",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 10.3529,
				height: 10.3529,
				fill: "white",
				transform: "translate(8.41162 11.6471)"
			})
		}) })
	]
});
export default SvgCommitmentsHelpStep4;
